<template>
  <div class="main-modal main-modal_w698 main-form">
    <div class="main-modal__title">
      <p>Zeitplan hinzufügen</p>
    </div>

    <div class="main-form__box main-form__box_flex">
      <!-- <div class="schedule-period"> -->
      <!-- <p class="schedule-weeks__title " v-text="$t('schedule.period')"></p> -->
      <div class="main-form__box_25 main-form__box_pr24">
        <p class="main-form__label" v-text="$t('schedule.from')"></p>
        <el-date-picker
          class="schedule-period__datepicker datepicker_no-icon"
          v-model="schedule.date.from"
          type="date"
          :placeholder="$t('request.dateHolder')"
          :pickerOptions="pickerOptionsFrom"
          style="width:100%"
        ></el-date-picker>
      </div>
      <div class="main-form__box_25 main-form__box_pr24">
        <p class="main-form__label" v-text="$t('schedule.to')"></p>
        <el-date-picker
          class="schedule-period__datepicker datepicker_no-icon"
          v-model="schedule.date.to"
          type="date"
          :placeholder="$t('request.dateHolder')"
          :pickerOptions="pickerOptionsTo"
          style="width:100%"
        ></el-date-picker>
      </div>
      <div class="main-form__box_25 main-form__box_pr24">
        <p class="main-form__label" v-text="$t('schedule.workingTime')"></p>

        <el-select
          v-model="schedule.time.from"
          :placeholder="$t('forms.select')"
          class="schedule-period__select"
          @change="changeTimeOptions"
        >
          <el-option
            v-for="item in timeOptionsFrom"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="main-form__box_25 main-form__box_pr24">
        <p class="main-form__label" v-text="$t('schedule.to')"></p>

        <el-select
          v-model="schedule.time.to"
          :placeholder="$t('forms.select')"
          class="schedule-period__select"
          @change="changeTimeOptions"
        >
          <el-option
            v-for="item in timeOptionsTo"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>

    <div class="main-form__box">
      <div class="schedule-weeks">
        <p class="main-form__label" v-text="$t('schedule.weekDays')"></p>

        <div class="schedule-weeks__btns">
          <div v-for="item of weekOptions" :key="item.key">
            <span
              @click="toSchedule(item.key)"
              :class="{
                'schedule-week_active': inWeekDays(item.key),
              }"
              v-text="item.text"
            ></span>
          </div>
        </div>
      </div>
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span
        @click="close"
        class="main-button main-button_cancel"
        v-text="$t('global.close')"
      ></span>

      <button @click="add" class="main-button">
        <span>{{ $t("global.add") }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'

const defaultTimeOptions = [
    { value: '00:00', label: '00:00' },
    { value: '01:00', label: '01:00' },
    { value: '02:00', label: '02:00' },
    { value: '03:00', label: '03:00' },
    { value: '04:00', label: '04:00' },
    { value: '05:00', label: '05:00' },
    { value: '06:00', label: '06:00' },
    { value: '07:00', label: '07:00' },
    { value: '08:00', label: '08:00' },
    { value: '09:00', label: '09:00' },
    { value: '10:00', label: '10:00' },
    { value: '11:00', label: '11:00' },
    { value: '12:00', label: '12:00' },
    { value: '13:00', label: '13:00' },
    { value: '14:00', label: '14:00' },
    { value: '15:00', label: '15:00' },
    { value: '16:00', label: '16:00' },
    { value: '17:00', label: '17:00' },
    { value: '18:00', label: '18:00' },
    { value: '19:00', label: '19:00' },
    { value: '20:00', label: '20:00' },
    { value: '21:00', label: '21:00' },
    { value: '22:00', label: '22:00' },
    { value: '23:00', label: '23:00' },
]

export default {
    data() {
        return {
            dateFrom: '',
            timeOptionsFrom: [...defaultTimeOptions],
            timeOptionsTo: [...defaultTimeOptions],
            weekOptions: [
                { key: 1, text: 'Mo' },
                { key: 2, text: 'Di' },
                { key: 3, text: 'Mi' },
                { key: 4, text: 'Do' },
                { key: 5, text: 'Fr' },
                { key: 6, text: 'Sa' },
                { key: 7, text: 'So' },
            ],
        }
    },
    computed: {
        ...mapGetters({
            schedule: 'specialists/schedule',
        }),
        pickerOptionsFrom() {
            return {
                firstDayOfWeek: 1,
                disabledDate: (time) => {
                    const from = new Date()

                    // disable if day is saturday or sunday
                    if (time.getDay() === 6 || time.getDay() === 0) {
                        return true
                    }

                    if (this.schedule.date.to) {
                        return time.getTime() > this.schedule.date.to.getTime() - 8.64e7
                    }

                    return time.getTime() < from.getTime() - 8.64e7
                },
            }
        },
        pickerOptionsTo() {
            return {
                firstDayOfWeek: 1,
                disabledDate: (time) => {
                    const from = new Date()

                    // disable if day is saturday or sunday
                    if (time.getDay() === 6 || time.getDay() === 0) {
                        return true
                    }

                    if (this.schedule.date.from) {
                        return time.getTime() < this.schedule.date.from.getTime() + 8.64e7
                    }

                    return time.getTime() < from.getTime() - 8.64e7
                },
            }
        },
    },
    methods: {
        ...mapMutations({
            clearSchedule: 'specialists/clearSchedule',
        }),
        ...mapActions({
            addSchedule: 'specialists/addSchedule',
        }),
        inWeekDays(id) {
            return this.schedule.days.lastIndexOf(id) !== -1
        },
        toSchedule(id) {
            const index = this.schedule.days.lastIndexOf(id)
            if (index === -1) {
                this.schedule.days.push(id)
                return
            }

            this.schedule.days.splice(index, 1)
        },
        close() {
            this.$emit('close')
        },
        async doAction() {
            return await this.addSchedule()
        },
        async add() {
            const isOkey = await this.doAction()
            if (isOkey) this.$emit('done')
        },
        changeTimeOptions() {
            const fromIndex = defaultTimeOptions.findIndex(
                (item) => item.value === this.schedule.time.from,
            )
            const toIndex = defaultTimeOptions.findIndex(
                (item) => item.value === this.schedule.time.to,
            )

            this.timeOptionsTo = defaultTimeOptions.slice(fromIndex)
            this.timeOptionsFrom = defaultTimeOptions.slice(0, toIndex)
        },
    },
    created() {
        this.changeTimeOptions()
    },
    beforeDestroy() {
        this.clearSchedule()
    },
}
</script>

<style lang="scss">
.schedule_buttons {
  width: 100%;
  color: #fff;
  display: flex;
  justify-content: center;
  margin-top: 45px;

  button,
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 156px;
    height: 45px;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    margin: 0 32.5px;
  }

  &_add,
  &_cancel {
    background-color: #61422d;
    transition: all 0.5s;
    cursor: pointer;
    position: relative;
    z-index: 9;

    &:hover {
      background-color: #fcee21;
      color: #000000 !important;
    }
  }
}
</style>
